import { create } from 'zustand'
import { newestFirst } from './alert-window-format'
import type { AlertWindowFire } from './alert-window-types'

/** The most rows one Alert Window panel keeps. */
export const MATCH_LIMIT = 500

const NONE: AlertWindowFire[] = []

interface AlertWindowMatchState {
  /** Per panel, newest first, at most MATCH_LIMIT. */
  byPanel: Record<string, AlertWindowFire[]>
  add: (panelId: string, f: AlertWindowFire) => void
  clear: (panelId: string) => void
}

/** A match store keeping at most limit rows per panel (tests use a small one). */
export const createAlertWindowMatchStore = (limit = MATCH_LIMIT) =>
  create<AlertWindowMatchState>((set) => ({
    byPanel: {},
    add: (panelId, f) =>
      set((s) => {
        const cur = s.byPanel[panelId] ?? NONE
        if (cur.some((x) => x.event_id === f.event_id)) return s
        return {
          byPanel: { ...s.byPanel, [panelId]: newestFirst([f, ...cur]).slice(0, limit) },
        }
      }),
    clear: (panelId) =>
      set((s) => {
        if (!(panelId in s.byPanel)) return s
        const { [panelId]: _drop, ...byPanel } = s.byPanel
        return { byPanel }
      }),
  }))

/**
 * This tab's fires per Alert Window panel, as its window's view delivers
 * them. Session-only: a reload starts empty.
 */
export const useAlertWindowMatchStore = createAlertWindowMatchStore()

/** One panel's fires (a stable empty list when it has none). */
export const usePanelMatches = (panelId: string) =>
  useAlertWindowMatchStore((s) => s.byPanel[panelId] ?? NONE)
